<template>
    <div class="question-abstract">

        <div class="question-abstract-title">
            <slot name="title"></slot>
        </div>

        <div class="question-abstract-content">
            <slot name="content"></slot>
        </div>

    </div>
</template>

<style scoped>
.question-abstract {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px;
}

.question-abstract-title {
    width: 100%;
    margin-bottom: 10px;
    text-align: left;
    font-size: 1.2em;
}

.question-abstract-content {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
</style>